import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import Card from "components/card/Card";
import { useWebinars, MediaItem } from "lib/mediaQueries";
import WebinarPlayerModal from "./WebinarPlayerModal";
import "./WebinarsSection.scss";

const PlayBadge: FC = () => (
  <span className="overview-webinar__badge" aria-hidden="true">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M8 5v14l11-7z" />
    </svg>
  </span>
);

/**
 * Overview dashboard section listing available webinars. Fails soft: a load
 * error renders an inline message and never breaks the rest of the dashboard.
 */
const WebinarsSection: FC = () => {
  const { t } = useTranslation();
  const { data, isError, isLoading } = useWebinars();
  const [selected, setSelected] = useState<MediaItem | null>(null);

  if (isLoading) {
    return (
      <div className="overview-webinars__state">{t("common.loading")}</div>
    );
  }
  if (isError) {
    return (
      <div className="overview-webinars__state">{t("webinars.loadError")}</div>
    );
  }

  const webinars = data ?? [];
  if (webinars.length === 0) {
    return <div className="overview-webinars__state">{t("webinars.empty")}</div>;
  }

  return (
    <>
      <div className="overview-webinars">
        {webinars.map((w) => (
          <button
            key={w.id}
            type="button"
            className="overview-webinar"
            onClick={() => setSelected(w)}
          >
            <Card customClass="overview-webinar__card">
              <PlayBadge />
              <div className="overview-webinar__title">{w.title}</div>
              {w.description && (
                <div className="overview-webinar__desc">{w.description}</div>
              )}
              <span className="overview-webinar__go">{t("webinars.watch")}</span>
            </Card>
          </button>
        ))}
      </div>
      <WebinarPlayerModal item={selected} onClose={() => setSelected(null)} />
    </>
  );
};

export default WebinarsSection;
